import { render, staticRenderFns } from "./HomeBrand.vue?vue&type=template&id=26f4c86c&scoped=true"
import script from "./HomeBrand.vue?vue&type=script&lang=js"
export * from "./HomeBrand.vue?vue&type=script&lang=js"
import style0 from "./HomeBrand.vue?vue&type=style&index=0&id=26f4c86c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f4c86c",
  null
  
)

export default component.exports